import React, { FC } from 'react'
import styled from 'styled-components'

const S = {
    Container: styled.div`
        display: inline-block;
        height: 100%;
        width: auto;
        position: relative;
        margin: 0 auto;
        overflow: hidden;
    `,
    Placeholder: styled.img`
        display: inline-block;
        position: relative;
        height: 100%;
        width: auto;
        opacity: 0;
        @media (max-width: 932px) {
            width: 100%;
            height: auto;
        }
    `,
    Mask: styled.svg`
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: 50%;
        mix-blend-mode: multiply;
    `,
    Image: styled.img`
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    `,
    Logo: styled.img`
        display: block;
        width: 17.5%;
        height: 34%;
        position: absolute;
        object-fit: contain;
        top: 55.6%;
        left: 17.2%;
        border-radius: 13px;
    `,
    Artwork: styled.img`
        display: block;
        top: 7%;
        height: 82%;
        left: 9%;
        width: 83%;
        position: absolute;
        object-fit: cover;
    `,
}

export interface StandSmallProps {
    background: string
    color: string
    logo: string
    video?: { url?: string }
}

const StandSmall: FC<StandSmallProps> = ({
    color,
    logo,
    background,
}: StandSmallProps) => (
    <S.Container>
        <S.Placeholder
            src="/assets/booths/booth_stand_placeholder_753x566.png"
        />
        { background && (
            <S.Artwork src={background} alt="" style={{ zIndex: 1 }} />
        ) }
        <S.Image
            src="/assets/booths/Appendee_Stand_Small_Base.png"
            alt=""
            style={{ zIndex: 4 }}
        />
        <S.Mask
            xmlns="http://www.w3.org/2000/svg"
            width="757"
            height="568"
            viewBox="0 0 757 568"
            style={{ zIndex: 3 }}
        >
            <path
                fill={color}
                d="M261.6189,412.0642 C261.6189,436.8492 261.3979,461.6372 261.7199,486.4182 C261.8659,497.6992 251.2879,508.3432 240.0399,508.1832 C210.9239,507.7712 181.7909,507.7192 152.6779,508.2622 C139.2799,508.5122 129.6409,496.9652 129.734218,485.1342 C130.1209,436.5652 129.8959,387.9902 129.9009,339.4182 C129.9029,325.2272 139.6289,315.5182 153.8769,315.5112 C181.6689,315.4972 209.4649,315.7912 237.2499,315.3932 C252.2189,315.1792 262.2249,326.8972 261.8309,339.7102 C261.0909,363.8082 261.6179,387.9442 261.6189,412.0642"
            />

            <path
                fill={color}
                d="M752.9998,0.9983 C750.6708,1.0193 748.3418,1.0603 746.0128,1.0603 C500.0698,1.0623 254.1278,1.0623 8.1848,1.0623 L1.0718,1.0623 L1.0718,7.6273 C1.0718,191.5893 1.0728,375.5523 1.0698,559.5143 C1.0698,561.6763 1.0288,563.8383 1.0078,565.999298 C0.6748,565.8333 0.0648,565.6843 0.0538,565.4983 C-0.0302,564.1723 0.0088,562.8383 0.0088,561.5073 L0.0088,-0.000701975309 C249.5078,-0.000701975309 499.0068,-0.000701975309 748.5058,0.0413 C750.0038,0.0413 751.5018,0.6653 752.9998,0.9983"
            />
            <path
                fill={color}
                d="M727.4812 311.9392L692.2822 311.9392C692.0492 313.3972 691.4972 315.2422 691.5012 317.0852 691.6092 373.1472 691.7922 429.2102 691.8272 485.2712 691.8282 486.7842 690.3362 488.2972 689.5412 489.8112 688.7312 488.1492 687.2182 486.4892 687.2142 484.8252 687.0682 429.2612 687.0662 373.6972 687.0432 318.1322 687.0422 316.1572 687.0432 314.1812 687.0432 311.5072 684.4982 311.5072 682.2302 311.3542 679.9912 311.5432 676.4472 311.8412 675.1562 310.1102 675.2502 306.8472 675.2782 305.8502 675.2462 304.8512 675.2462 303.8532 675.2512 296.7832 675.5512 296.4692 682.4842 296.4662 697.2692 296.4612 712.0552 296.4652 727.4772 296.4652 727.4772 288.8582 727.5032 281.6032 727.4722 274.3482 727.3862 254.2202 727.2562 234.0922 727.1822 213.9642 727.1272 198.8992 727.2412 183.8342 727.0652 168.7712 726.9672 160.3342 726.3772 151.9032 726.1112 143.4662 725.8422 134.9792 726.4042 126.3982 725.3272 118.0212 723.9312 107.1672 721.4202 96.4412 719.0262 85.7432 718.5822 83.7602 716.4122 82.1642 714.9272 80.2472 719.3242 76.6652 723.3392 77.4972 725.3002 83.8512 726.9982 89.3532 727.9902 95.0892 729.0602 100.7662 735.7212 136.0932 732.3612 171.8102 732.9382 207.3612 733.3822 234.7382 732.8602 262.1302 732.7702 289.5162 732.7622 291.6422 732.7692 293.7692 732.7692 296.3992 737.2682 295.9782 739.6392 297.2092 739.5422 302.0412 739.3572 311.1692 739.6192 311.1742 732.9882 312.7502L732.9882 524.4542C728.7812 525.8792 726.9582 524.8182 727.0632 520.5732 727.4082 506.6502 727.7552 492.7252 727.8472 478.7992 727.9652 460.8562 727.8612 442.9112 727.8132 424.9652 727.7162 389.0332 727.5922 353.0992 727.4812 317.1672 727.4762 315.5312 727.4812 313.8952 727.4812 311.9392M192.9314 39.8503C190.7074 40.5623 188.4894 41.8673 186.2574 41.8923 170.6194 42.0723 154.9774 41.9863 139.3364 41.9883 101.1844 41.9923 70.9984 72.0793 70.9744 110.1043 70.9114 212.0593 70.8564 314.0133 70.7614 415.9673 70.7384 439.9143 70.5724 463.8633 70.4644 487.8103 70.4594 488.9723 70.6884 490.2683 70.2514 491.2543 69.8974 492.0553 68.7564 492.8233 67.8674 492.95878 67.3244 493.0363 66.1894 491.9743 66.0394 491.2723 65.7334 489.8363 65.8934 488.2983 65.8954 486.8023 65.9874 406.9703 66.0354 327.1373 66.1974 247.3043 66.2934 200.2403 66.2084 153.1713 66.8994 106.1153 67.3554 74.9983 90.3984 47.3143 120.7524 39.9593 125.7064 38.7583 130.8824 37.9633 135.9674 37.8983 154.7494 37.6583 173.5364 37.8033 192.3224 37.8033 192.5254 38.4853 192.7284 39.1673 192.9314 39.8503"
            />
            <path
                fill={color}
                d="M687.3416 110.053C691.9336 108.965 691.8546 112.127 691.8786 114.911 691.9746 126.044 691.9976 137.178 692.0086 148.311 692.0366 177.227 692.1286 206.144 692.0296 235.061 691.9696 252.725 691.6456 270.388 691.2856 288.05 691.2606 289.258 689.9486 290.439 689.2366 291.633 688.5056 290.456 687.1376 289.28 687.1356 288.101 687.0296 229.434 687.0386 170.766 687.0496 112.099 687.0496 111.457 687.2286 110.815 687.3416 110.053M565.6355 37.8689C575.9065 37.8689 586.1775 37.9759 596.4465 37.8379 606.0345 37.7089 615.6675 36.6039 625.1955 37.2369 635.7415 37.9369 646.2445 40.3939 655.1945 46.3729 661.9045 50.8559 668.4535 55.9039 674.0005 61.7239 681.9645 70.0789 686.9085 80.4629 689.8595 91.6469 690.1535 92.7619 688.7925 94.3119 688.1995 95.6599 687.0435 94.9309 685.3705 94.4749 684.8175 93.4279 681.7985 87.7119 679.0485 81.8539 676.2175 76.0389 672.1715 67.7279 666.2065 61.2619 658.6145 55.8889 646.5485 47.3489 633.5105 42.5289 618.6305 42.8169 610.4895 42.9749 602.3405 42.9309 594.1975 42.7869 586.2625 42.6469 578.3235 42.3929 570.4065 41.8889 568.5835 41.7719 566.8405 40.4279 565.0615 39.6489 565.2525 39.0559 565.4445 38.4619 565.6355 37.8689M559.4304 39.9612C557.2624 40.6372 555.0994 41.8862 552.9254 41.9052 507.0424 42.2972 461.1594 42.6052 415.2764 42.7842 406.0004 42.8202 396.7164 42.3822 387.4514 41.8882 385.6404 41.7922 383.8974 40.4272 382.1224 39.6472 382.2504 39.2092 382.3784 38.7702 382.5064 38.3312L558.9764 38.3312C559.1274 38.8742 559.2794 39.4182 559.4304 39.9612M376.3181 39.8401C374.1251 40.5561 371.9391 41.8751 369.7381 41.8991 332.2041 42.3081 294.6681 42.6831 257.1321 42.7831 239.7141 42.8301 222.2931 42.3501 204.8791 41.8841 202.7741 41.8271 200.7061 40.3591 198.6211 39.5451 198.7521 39.1021 198.8821 38.6581 199.0121 38.2151L375.8981 38.2151C376.0381 38.7571 376.1781 39.2981 376.3181 39.8401M589.6707 343.4881C588.4737 341.0701 586.5057 338.7431 586.2077 336.2181 584.5707 322.3621 583.7087 308.4581 586.2217 294.5871 586.2927 294.1951 586.7257 293.8681 587.7887 293.5101 590.7887 309.9201 591.6437 326.4441 591.6977 343.0301 591.0227 343.1821 590.3467 343.3361 589.6707 343.4881M581.3386 291.4148C582.6576 306.7208 583.7496 322.0408 582.0466 338.2128 580.9736 336.7158 579.2446 335.3438 578.9306 333.7018 576.3486 320.2218 576.4756 306.6698 578.5506 293.1268 578.6416 292.5348 579.2126 292.0148 579.5606 291.4608 580.1526 291.4458 580.7456 291.4308 581.3386 291.4148M665.8298 358.8494C674.4858 364.1364 676.4388 368.8284 674.6518 380.1204 667.1888 379.4574 667.1888 379.3044 666.9948 372.5434 666.8638 367.9884 666.2388 363.4474 665.8298 358.8494M661.9714 373.1521C658.1144 373.7191 655.6104 372.9931 656.0344 368.1181 656.3604 364.3641 656.0994 360.5591 656.0994 356.7561 662.3054 357.4751 664.8434 364.7021 661.9714 373.1521"
            />
        </S.Mask>
        <S.Image
            src="/assets/booths/Appendee_Stand_Small_Color.png"
            alt=""
            style={{ zIndex: 2 }}
        />
        { logo && (
            <S.Logo src={logo} alt="" style={{ zIndex: 5 }} />
        ) }
    </S.Container>
)

export default StandSmall
